import _slicedToArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import * as R from 'ramda';
import { getCellValue } from '../utils';

var filterText = function filterText(value, searchValue) {
  return value.includes(searchValue);
};

var filterRange = function filterRange(value, searchValue) {
  var _searchValue = _slicedToArray(searchValue, 2),
      _searchValue$ = _searchValue[0],
      min = _searchValue$ === void 0 ? -Infinity : _searchValue$,
      _searchValue$2 = _searchValue[1],
      max = _searchValue$2 === void 0 ? Infinity : _searchValue$2;

  var hasFilter = min !== -Infinity || max !== Infinity;

  if (isNaN(value) || !value) {
    return !hasFilter;
  }

  return value >= min && value <= max;
};

var formatText = function formatText(value) {
  return value.toString().toLowerCase();
};
/**
 * When `_original` appears, it means its in CrudTable, and we need to search both in original data and changed data, to keep row visible when data changed.
 */


export var filterFnCollection = {
  isNil: function isNil(row, id, searchValue) {
    var _original = row.original._original;
    var colValue = row.getValue(id);
    var result = searchValue === 'isNil' ? R.isNil(colValue) : R.isNotNil(colValue);

    if (_original) {
      var originalValue = getCellValue(id, _original);
      result = result || (searchValue === 'isNil' ? R.isNil(originalValue) : R.isNotNil(originalValue));
    }

    return result;
  },
  text: function text(row, id, searchValue) {
    var _original = row.original._original;
    var colValue = row.getValue(id);
    var formattedSearchValue = formatText(searchValue);
    var formattedValue = formatText(colValue !== null && colValue !== void 0 ? colValue : '');
    var result = filterText(formattedValue, formattedSearchValue);

    if (_original) {
      var originalValue = getCellValue(id, _original);
      var formattedOriginalValue = formatText(originalValue !== null && originalValue !== void 0 ? originalValue : '');
      result = result || filterText(formattedOriginalValue, formattedSearchValue);
    }

    return result;
  },
  exact: function exact(row, id, searchValue) {
    var _original = row.original._original;
    var colValue = row.getValue(id);
    var formattedSearchValue = formatText(searchValue);
    var formattedValue = formatText(colValue !== null && colValue !== void 0 ? colValue : '');
    var result = formattedValue === formattedSearchValue;

    if (_original) {
      var originalValue = getCellValue(id, _original);
      var formattedOriginalValue = formatText(originalValue !== null && originalValue !== void 0 ? originalValue : '');
      result = result || formattedOriginalValue === formattedSearchValue;
    }

    return result;
  },
  range: function range(row, id, searchValue) {
    var _original = row.original._original;

    var _ref = searchValue !== null && searchValue !== void 0 ? searchValue : [],
        _ref2 = _slicedToArray(_ref, 2),
        min = _ref2[0],
        max = _ref2[1];

    var formattedMax = max && !isNaN(+max) ? +max : Infinity;
    var formattedMin = min && !isNaN(+min) ? +min : -Infinity;
    var colValue = row.getValue(id);
    var result = filterRange(colValue, [formattedMin, formattedMax]);

    if (_original) {
      var originalValue = getCellValue(id, _original);
      result = result || filterRange(originalValue, [formattedMin, formattedMax]);
    }

    return result;
  }
};